import { useHttp } from '../http'

export const useClubHttp = () => {

    const find = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().get(`clubs/${id}`, payload)
    }

    const create = <T>(payload: any): Promise<T> => {
        return useHttp().post(`clubs`, payload)
    }

    const update = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().put(`clubs/${id}`, payload)
    }

    const get = <T>(payload: any): Promise<T> => {
        return useHttp().get(`clubs`, payload)
    }

    const del = <T>(id: number): Promise<T> => {
        return useHttp().del(`clubs/${id}`)
    }

    const photo = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().post(`clubs/${id}/photo`, payload)
    }

    return {
        find,
        create,
        update,
        get,
        del,
        photo
    }
}
